import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { AppUpdateProvider } from './contexts/AppUpdateContext';
import { OfflineProvider } from './contexts/OfflineContext';
import { PwaInstallProvider } from './contexts/PwaInstallContext';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <OfflineProvider>
      <PwaInstallProvider>
        <AppUpdateProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </AppUpdateProvider>
      </PwaInstallProvider>
    </OfflineProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
